export const environment = {
    production: true,
    apiUrl: 'https://devapi.mobility.hyundai.ru',
    urlCustomerService:'/customer',
    stompString: 'wss://crm.mobility.hyundai.ru/ws',
    CRM: false,
};
